import { Link } from "react-router-dom";
import { useLang } from "@/i18n/LanguageContext";
import { LANGS } from "@/i18n/translations";
import { AuraMark } from "./AuraMark";
import { FlagRow } from "./Flags";

export const Footer = () => {
  const { t, lang, setLang } = useLang();
  return (
    <footer className="relative border-t border-white/10 pt-20 pb-10 overflow-hidden" data-testid="footer">
      <div className="mx-auto max-w-7xl px-5 md:px-10">
        <div className="flex flex-wrap items-start justify-between gap-8">
          <div className="flex items-center gap-3">
            <AuraMark className="w-10 h-10" />
            <p className="text-slate-300 max-w-xs">{t.footer.tagline}</p>
          </div>
          <div className="flex gap-2">
            {LANGS.map((l) => (
              <button key={l.code} onClick={() => setLang(l.code)} data-testid={`footer-lang-${l.code}`}
                className={`font-mono text-xs px-3 py-1.5 rounded-full transition-colors ${lang === l.code ? "bg-white text-[#050713]" : "border border-white/15 text-slate-300 hover:text-white"}`}>
                {l.short}
              </button>
            ))}
          </div>
        </div>
        <div className="relative mt-16 overflow-visible" data-testid="footer-wordmark">
          <div className="orbit-ring pointer-events-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[46vw] h-[46vw] max-w-[640px] max-h-[640px] opacity-60" aria-hidden="true" />
          <p className="relative font-hero font-black leading-none tracking-[-0.02em] text-[18vw] md:text-[14vw] select-none" aria-label="Aura_">
            {"AURA".split("").map((ch, i) => <span key={i} className="giant-letter text-chrome">{ch}</span>)}
            <span className="giant-letter font-bold text-[#f43f5e]">_</span>
          </p>
          <div className="relative mt-4 flex flex-wrap items-center gap-x-6 gap-y-3 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-300">
            <span>TikTok Live</span><span className="text-[#f43f5e]">✦</span><span>Creator</span><span className="text-[#f43f5e]">✦</span><span>{t.footer.tagline}</span>
            <FlagRow labels={false} className="ml-auto gap-2 [&_.flag]:w-7 [&_.flag]:h-5 [&_.flag-ch]:w-5" testid="footer-flag-row" />
          </div>
        </div>
        <div className="mt-8 flex flex-wrap justify-between gap-4 text-sm text-slate-400">
          <p>© {new Date().getFullYear()} Agenzia Aura_. {t.footer.rights}</p>
          <Link to="/admin" data-testid="footer-owner-link" className="hover:text-white transition-colors">{t.footer.owner}</Link>
        </div>
      </div>
    </footer>
  );
};
